import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewChildren, QueryList, ElementRef, OnDestroy, AfterViewInit, NgZone, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { WhiteLabelService } from 'src/app/_service/white-label.service';
import { TVNavigationService, Region } from 'src/app/_service/tv-navigation.service';
import { DeviceService } from 'src/app/_service/tv-detect.service';
import { TvPurchaseRedirectService } from 'src/app/_service/tv-purchase-redirect.service';
import { URLS } from 'src/app/constants/URLS';
import { getVideoThumbnail } from 'src/app/utils/media-url.utils';
import { AxinomDrmService } from 'src/app/_service/axinom-drm.service';
import { DrmCapabilityService } from 'src/app/_service/drm-capability.service';
import { MycontentserviceService } from 'src/app/_service/mycontentservice.service';
import { environment } from 'src/environments/environment';

declare let shaka: any;
declare let window: any;

export interface BannerItem {
  vidLibId: string | number;
  title: string;
  title_img?: string;
  channel_desc?: string;
  pg_rating?: string;
  duration?: string;
  category?: string;
  description?: string;
  genres?: string[];
  preparedVideoType: 'FREE' | 'Sub' | 'PPV';
  isChannelSubscribed?: boolean;
  isPPVSubscribed?: boolean;
  isInWatchList?: boolean;
  channelId?: string | number;
  videoType?: string;
  durationInSeconds?: number;
  videoFileSize?: number;
  secondsWatched?: number;
  series_id?: string | number;
  series_name?: string;
  season_number?: number;
  episode_number?: number;
  ppv_subscribed?: number;
  ppv_unsubscribed?: number;
  routerLink?: string;
  queryParams?: any;
  sub_value?: number;
  unSub_value?: number;
  imageError?: boolean;
  latestTrailer?: any;
}

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.css']
})
export class BannerComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() banners: BannerItem[] = [];
  @Input() showTitle: boolean = true;
  @Input() showMetaInfo: boolean = true;
  @Input() showDescription: boolean = true;
  @Input() showGenres: boolean = true;
  @Input() showButtons: boolean = true;
  @Input() showWatchlist: boolean = true;
  @Input() subscribeText: string = 'SUBSCRIBE_TO_WATCH';
  @Input() rentText: string = 'WATCH_FOR';
  @Input() watchText: string = 'Watch Now';
  @Input() customCarouselOptions?: any;
  @Input() baseImageUrl?: string;
  @Input() baseTitleImageUrl?: string;

  @Output() subscribe = new EventEmitter<BannerItem>();
  @Output() rent = new EventEmitter<BannerItem>();
  @Output() watch = new EventEmitter<BannerItem>();
  @Output() watchlistToggle = new EventEmitter<BannerItem>();
  @Output() bannerClick = new EventEmitter<BannerItem>();

  @ViewChild('bannerCarousel', { static: false }) bannerCarousel: ElementRef;
  @ViewChild('carouselTrack', { static: false }) carouselTrack: ElementRef;
  @ViewChildren('actionButton') actionButtons: QueryList<ElementRef>;

  imgUrl:string = URLS.imgUrl;
  isTV = false;
  currentIndex = 0;
  translateX = 0;
  isAnimating = false;
  itemWidth = 0;
  maxIndex = 0;
  showNavigation = true;
  showDots = true;

  isDragging = false;
  private startX = 0;
  private startY = 0;
  private currentX = 0;
  private currentY = 0;
  private lastX = 0;
  private lastY = 0;
  private initialTranslateX = 0;
  private startTime = 0;
  private lastTime = 0;
  private velocityX = 0;
  private velocityY = 0;
  private isHorizontalSwipe = false;
  private isVerticalSwipe = false;
  private swipeDecided = false;
  private touchStarted = false;
  private moved = false;
  private minSwipeDistance = 10;
  private snapThreshold = 0.3;    

  private isPaused = false;

  private resizeObserver?: ResizeObserver;
  private animationFrameId = 0;

  private autoSlideTimer: any = null;
  private AUTO_SLIDE_DELAY = 3000;
  activeVideoBannerId: number | null = null;
  isTrailerPlaying = false;
  private trailerCheckTimer: any = null;
  private preloadVideoEl?: HTMLVideoElement;

  @ViewChild('heroVideo') heroVideo?: ElementRef<HTMLVideoElement>;
  isMuted = true;
  private userMutedManually = false;
  private wasHidden = false;
  private blockNextNavigation = false;

  private trailerStartTime: number = 0;

  private shakaPlayer: any = null;
  private shakaVideoEl: HTMLVideoElement | null = null;
  private fpCertificate: ArrayBuffer | null = null;
  private fpKeySession: MediaKeySession | null = null;
  private visibilityObserver?: IntersectionObserver;

  // TV Navigation integration
  private destroy$ = new Subject<void>();
  private generatedRegionId: string = '';
  isTvFocused = false;
  focusedButtonIndex = -1;

  constructor(
    private ngZone: NgZone,
    private whitelabelService: WhiteLabelService,
    private router: Router,
    private tvNavService: TVNavigationService,
    private deviceService: DeviceService,
    private axinomService: AxinomDrmService,
    private drmCapability: DrmCapabilityService,
    private mycontentserviceService: MycontentserviceService,
    private tvPurchaseRedirect: TvPurchaseRedirectService
    ) { }

  ngOnInit(): void {
    this.isTV = this.deviceService.isTV();
    this.mergeOptions();
    this.setupCarousel();
    this.banners.forEach(banner => {
      this.checkBannerTitleImage(banner);
    });
  }

  checkBannerTitleImage(banner: any) {
    let url: string;
    if (banner.series_id) {
      url = `${this.imgUrl}SER_${banner.series_id}_title_img.png`;
    } else {
      url = getVideoThumbnail(banner, '_title_img.png');
    }
    const img = new Image();
    img.src = url;
    img.onload = () => {
      banner.titleImageUrl = url;
      banner.showTitleImage = true;
    };
    img.onerror = () => {
      banner.titleImageUrl = null;
      banner.showTitleImage = false;
    };
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.calculateDimensions();
      this.setupEventListeners();
      this.setupResizeObserver();
      this.setupVisibilityObserver();
      this.startAutoSlide();
    }, 50);

    // TV Navigation integration
    if (this.deviceService.isTV()) {
      // Stable ID — was 'home-banner-' + Date.now() before, but a fresh ID per
      // mount made saved focus positions for the banner unrestorable on the
      // next mount and broke focus restoration after navigating back from
      // details (the new banner instance would auto-activate and overwrite the
      // saved carousel position with its own id).
      this.generatedRegionId = 'home-banner';

      setTimeout(() => {
        this.registerWithNavigation();
      }, 50);  // Shorter timeout than carousels = registers first

      // Re-register when banner items change
      this.actionButtons?.changes
        .pipe(takeUntil(this.destroy$))
        .subscribe(() => {
          this.registerWithNavigation();
        });

      // Subscribe to boundary events for slide navigation via D-pad
      this.tvNavService.boundary$
        .pipe(takeUntil(this.destroy$))
        .subscribe(event => {
          if (event.regionId === this.generatedRegionId) {
            if (event.direction === 'right') {
              this.next();
            } else if (event.direction === 'left') {
              if (this.currentIndex > 0) {
                this.prev();
              } else {
                // First slide, left arrow → move to sidebar
                this.tvNavService.switchToSidebar();
              }
            }
          }
        });

      // Subscribe to focus changes
      this.tvNavService.focus$
        .pipe(takeUntil(this.destroy$))
        .subscribe(focusKey => {
        // Clear all button focus
        this.actionButtons?.forEach(btn => {
          btn.nativeElement.classList.remove('tv-focus');
        });

        if (focusKey && focusKey.startsWith(this.generatedRegionId + ':')) {
          this.isTvFocused = true;
          // On TV: start auto-slide WHILE banner is focused so the user sees
          // hero slides cycle as they view the banner. On web: keep historical
          // behavior — pause auto-slide while focused (user is interacting).
          if (this.isTV) {
            this.startAutoSlide();
          } else {
            this.clearAutoSlide();
          }
          this.focusedButtonIndex = parseInt(focusKey.split(':')[1], 10);
          // Apply focus to the button within the current slide's filtered set
          const currentSlideButtons = this.getButtonsForCurrentSlide();
          const focusedBtn = currentSlideButtons[this.focusedButtonIndex];
          if (focusedBtn) {
            focusedBtn.nativeElement.classList.add('tv-focus');
          }
        } else {
          const wasFocused = this.isTvFocused;
          this.isTvFocused = false;
          this.focusedButtonIndex = -1;
          if (wasFocused) {
            // On TV: stop auto-slide when focus leaves banner. No peripheral
            // motion while user is on a carousel below. On web: resume auto-
            // slide when focus leaves (mouse moved away from banner).
            if (this.isTV) {
              this.clearAutoSlide();
            } else {
              this.startAutoSlide();
            }
          }
        }
      });
    }
  }

  ngOnDestroy(): void {
    // TV Navigation cleanup
    this.destroy$.next();
    this.destroy$.complete();

    if (this.deviceService?.isTV() && this.generatedRegionId) {
      this.tvNavService.unregisterRegion(this.generatedRegionId);
    }

    this.clearAutoSlide();
    this.destroyTrailer();
    this.userMutedManually = false;
    this.isMuted = true;
    this.visibilityObserver?.disconnect();
    this.resizeObserver?.disconnect();
    cancelAnimationFrame(this.animationFrameId);
    this.removeEventListeners();
  }

  private registerWithNavigation(): void {
    if (!this.actionButtons || this.actionButtons.length === 0) return;

    // Only register buttons from the CURRENT visible slide
    // Each slide has its own set of action buttons; we need to filter
    // to avoid registering off-screen buttons from other slides
    const currentSlideButtons = this.getButtonsForCurrentSlide();
    if (currentSlideButtons.length === 0) return;

    const region: Region = {
      id: this.generatedRegionId,
      type: 'banner',
      elementRef: this.bannerCarousel,
      focusableItems: currentSlideButtons
    };

    this.tvNavService.registerRegion(region);
  }

  /**
   * Get action buttons that belong to the currently visible slide.
   * Uses DOM position: buttons whose parent slide matches currentIndex.
   */
  private getButtonsForCurrentSlide(): ElementRef[] {
    if (!this.actionButtons) return [];

    const slides = this.carouselTrack?.nativeElement?.querySelectorAll('.carousel-slide');
    if (!slides || slides.length === 0) return this.actionButtons.toArray();

    const currentSlide = slides[this.currentIndex];
    if (!currentSlide) return this.actionButtons.toArray();

    return this.actionButtons.toArray().filter(btn =>
      currentSlide.contains(btn.nativeElement)
    );
  }

  private mergeOptions(): void {
    if (this.customCarouselOptions) {
      this.customOptions = { ...this.customOptions, ...this.customCarouselOptions };
    }
  }

  private setupCarousel(): void {
    this.maxIndex = Math.max(0, this.banners.length - 1);
    this.updateResponsiveSettings();
  }

  private updateResponsiveSettings(): void {
    const screenWidth = window.innerWidth;
    const responsiveConfig = this.getResponsiveConfigForScreen(screenWidth);
    this.showNavigation = responsiveConfig.nav !== false;
    this.showDots = responsiveConfig.dots !== false;
  }

  private getResponsiveConfigForScreen(screenWidth: number) {
    const breakpoints = Object.keys(this.customOptions.responsive).map(key => parseInt(key)).sort((a, b) => b - a);
    for (const breakpoint of breakpoints) {
      if (screenWidth >= breakpoint) {
        return this.customOptions.responsive[breakpoint];
      }
    }
    const smallestBreakpoint = Math.min(...breakpoints);
    return this.customOptions.responsive[smallestBreakpoint];
  }

  @HostListener('window:resize')
  onResize(): void {
    this.updateResponsiveSettings();
    requestAnimationFrame(() => this.calculateDimensions());
  }

  private calculateDimensions(): void {
    if (!this.carouselTrack) return;
    const container = this.carouselTrack.nativeElement.parentElement;
    this.itemWidth = container.offsetWidth;
    this.maxIndex = Math.max(0, this.banners.length - 1);
    this.updateTransform();
  }
  
  private updateTransform(): void {
    const target = -this.currentIndex * this.itemWidth;
    this.translateX = target;
  }

  private setupResizeObserver(): void {
    if (typeof ResizeObserver === 'undefined' || !this.carouselTrack) return;
    this.resizeObserver = new ResizeObserver(() => {
      requestAnimationFrame(() => this.calculateDimensions());
    });
    this.resizeObserver.observe(this.carouselTrack.nativeElement.parentElement);
  }

  private setupVisibilityObserver(): void {
    const el = this.bannerCarousel?.nativeElement;
    if (!el) return;
    this.visibilityObserver = new IntersectionObserver(
      (entries) => {
        const isVisible = entries[0]?.isIntersecting;
        if (!isVisible && this.isTrailerPlaying) {
          this.destroyTrailer();
          this.startAutoSlide();
        }
      },
      { threshold: 0.3 }
    );
    this.visibilityObserver.observe(el);
  }

  // Bound event handler references — must use the SAME reference for
  // both addEventListener and removeEventListener
  private boundTouchStart = this.onTouchStart.bind(this);
  private boundTouchMove = this.onTouchMove.bind(this);
  private boundTouchEnd = this.onTouchEnd.bind(this);
  private boundMouseDown = this.onMouseDown.bind(this);
  private boundMouseMove = this.onMouseMove.bind(this);
  private boundMouseUp = this.onMouseUp.bind(this);

  private setupEventListeners(): void {
    const el = this.carouselTrack.nativeElement;
    el.addEventListener('touchstart', this.boundTouchStart, { passive: false });
    el.addEventListener('touchmove', this.boundTouchMove, { passive: false });
    el.addEventListener('touchend', this.boundTouchEnd, { passive: false });
    el.addEventListener('touchcancel', this.boundTouchEnd, { passive: false });
    el.addEventListener('mousedown', this.boundMouseDown, { passive: false });
    document.addEventListener('mousemove', this.boundMouseMove, { passive: false });
    document.addEventListener('mouseup', this.boundMouseUp, { passive: false });
  }

  private removeEventListeners(): void {
    const el = this.carouselTrack?.nativeElement;
    if (!el) return;
    el.removeEventListener('touchstart', this.boundTouchStart);
    el.removeEventListener('touchmove', this.boundTouchMove);
    el.removeEventListener('touchend', this.boundTouchEnd);
    el.removeEventListener('touchcancel', this.boundTouchEnd);
    el.removeEventListener('mousedown', this.boundMouseDown);
    document.removeEventListener('mousemove', this.boundMouseMove);
    document.removeEventListener('mouseup', this.boundMouseUp);
  }

  next(): void {
    if (this.currentIndex >= this.maxIndex) {
      this.currentIndex = 0; 
    } else {
      this.currentIndex++;
    }
    this.smoothSlide();
  }
  
  prev(): void {
    if (this.currentIndex <= 0) return;
    this.currentIndex--; 
    this.smoothSlide();
  }
  
  goToSlide(idx: number): void {
    if (idx < 0 || idx > this.maxIndex) return;
    this.currentIndex = idx;
    this.smoothSlide();
  }
  
  private smoothSlide(): void {
    this.destroyTrailer();
    this.clearAutoSlide();
    this.isAnimating = true;
    this.updateTransform();
    setTimeout(() => {
      this.isAnimating = false;
      this.startAutoSlide();
      // Re-register with navigation after slide change to update focusable buttons
      if (this.deviceService.isTV() && this.generatedRegionId) {
        this.registerWithNavigation();
        // Reset focus to first button of the new slide
        if (this.isTvFocused) {
          this.tvNavService.activateRegion(this.generatedRegionId, 0);
        }
      }
    }, 300);
  }  

// private boundTouchStart: any;
// private boundTouchMove: any;
// private boundTouchEnd: any;
  private onTouchStart(e: TouchEvent): void {
    if (e.touches.length !== 1) return;
    this.clearAutoSlide();  
    const t = e.touches[0];
    this.isDragging = true;
    this.swipeDecided = false;
    this.touchStarted = true;
    this.moved = false;
    this.startX = this.lastX = this.currentX = t.clientX;
    this.startY = this.lastY = this.currentY = t.clientY;
    this.initialTranslateX = this.translateX;
    this.startTime = this.lastTime = performance.now();
    this.velocityX = 0;
  }
  
  private onTouchMove(e: TouchEvent): void {
    if (!this.isDragging || e.touches.length !== 1) return;
    const t = e.touches[0];
    const deltaX = t.clientX - this.startX;
    const deltaY = t.clientY - this.startY;
    const THRESHOLD = 8; 
    if (!this.swipeDecided) {
      if (Math.abs(deltaY) > Math.abs(deltaX) && Math.abs(deltaY) > THRESHOLD) {
        this.isDragging = false;
        this.resetDragState(); 
        return; 
      }
      if (Math.abs(deltaX) > THRESHOLD) {
        this.swipeDecided = true;
      } else {
        return;
      }
    }
    this.moved = true;
    this.currentX = t.clientX;
    const now = performance.now();
    if (now - this.lastTime > 16) {
      this.velocityX = (this.currentX - this.lastX) / (now - this.lastTime);
      this.lastX = this.currentX;
      this.lastTime = now;
    }
    const moveDeltaX = this.currentX - this.startX; 
    this.updateCarouselPosition(moveDeltaX);
    e.preventDefault();
  }
  
  private onTouchEnd(e: TouchEvent): void {
    if (!this.touchStarted) return;
    if (!this.moved || !this.swipeDecided) {
      this.resetDragState();
      return;
    }
    const deltaX = this.currentX - this.startX;
    const duration = Math.max(1, performance.now() - this.startTime);
    const velocity = this.velocityX;
    if (Math.abs(velocity) > 0.4 && duration < 400) {
      this.currentIndex += (velocity < 0 ? 1 : -1);
    } else {
      const swipeProgress = -(this.translateX + this.currentIndex * this.itemWidth) / this.itemWidth;
      if (swipeProgress > 0.15) this.currentIndex++;
      if (swipeProgress < -0.15) this.currentIndex--;
    }
    this.currentIndex = Math.max(0, Math.min(this.currentIndex, this.maxIndex));
    this.smoothSlide();
    this.resetDragState();
  }
  
  private resetDragState(): void {
    this.isDragging = false;
    this.touchStarted = false;
    this.moved = false;
    this.swipeDecided = false;
    this.isHorizontalSwipe = false;
    this.isVerticalSwipe = false;
    this.velocityX = 0;
    this.velocityY = 0;
  }

  private onMouseDown(e: MouseEvent): void {
    if (!this.customOptions.mouseDrag) return;
    this.isDragging = true;
    this.startX = this.currentX = this.lastX = e.clientX;
    this.initialTranslateX = this.translateX;
    this.startTime = this.lastTime = Date.now();
    this.velocityX = 0;
    e.preventDefault();
  }
  
  private onMouseMove(e: MouseEvent): void {
    if (!this.isDragging) return;
    const now = Date.now();
    this.currentX = e.clientX;
    if (now - this.lastTime > 16) {
      this.velocityX = (this.currentX - this.lastX) / (now - this.lastTime);
      this.lastX = this.currentX;
      this.lastTime = now;
    }
    const deltaX = this.currentX - this.startX;
    this.updateCarouselPosition(deltaX);
    e.preventDefault();
  }
  
  private onMouseUp(e: MouseEvent): void {
    if (!this.isDragging) return;
    this.endDrag();
    this.isDragging = false;
  }
  
  private updateCarouselPosition(deltaX: number): void {
    let newX = this.initialTranslateX + deltaX * 0.85; 
    const maxX = 0;
    const minX = -this.itemWidth * this.maxIndex;
    if (newX > maxX) newX = maxX + (newX - maxX) * 0.3;
    if (newX < minX) newX = minX + (newX - minX) * 0.3;
    this.ngZone.runOutsideAngular(() => (this.translateX = newX));
  }
  
  private endDrag(): void {
    const deltaX = this.currentX - this.startX;
    const duration = Date.now() - this.startTime;
    const slideSize = this.itemWidth;
    if (Math.abs(this.velocityX) > 0.35 && duration < 250) {
      this.currentIndex += (this.velocityX < 0 ? 1 : -1);
    } else {
      const swipeProgress = -(this.translateX + this.currentIndex * this.itemWidth) / this.itemWidth;
      if (swipeProgress > 0.15) this.currentIndex++;
      if (swipeProgress < -0.15) this.currentIndex--;
    }
    this.currentIndex = Math.max(0, Math.min(this.currentIndex, this.maxIndex));
    this.smoothSlide();
  }

  customOptions = {
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    navSpeed: 600,
    nav: false,
    autoplay: false,
    autoplayTimeout: 4000, 
    autoplayHoverPause: true,
    navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
    items: 1,
    margin: 0,
    responsive: {
      0: {
        nav: false,
        dots: true
      },
      600: {
        nav: false,
        dots: true
      },
      1000: {
        nav: true,
        dots: true
      }
    }
  };

  getHorizontalImage(banner: any): string {
    const isMobile = window.innerWidth <= 768;
    const suffix = isMobile ? '_thumb.jpg' : '_thumb_b_high.jpg';
    return banner?.series_id ? `${this.imgUrl}SER_${banner.series_id}${suffix}` : getVideoThumbnail(banner, suffix);
  }
  
  onHeroImageError(event: Event, banner: any) {
    const img = event.target as HTMLImageElement;
    if (img.dataset['retried'] === "1") {
      console.warn("⛔ Hero image failed twice — no more retries");
      return;
    }
    img.dataset['retried'] = "1";
    const fallbackSuffix = '_thumb.jpg';
    img.src = banner?.series_id ? `${this.imgUrl}SER_${banner.series_id}${fallbackSuffix}` : getVideoThumbnail(banner, fallbackSuffix);
  }  

  getVerticalImage(banner: BannerItem): string {
    if (banner?.series_id) {
      return `${this.imgUrl}SER_${banner?.series_id}_thumb_v.jpg`;
    } else {
      return getVideoThumbnail(banner, '_thumb_v.jpg');
    }
  }

  getTitleImage(banner: BannerItem): string {
    if (this.baseTitleImageUrl) {
      return `${this.baseTitleImageUrl}${banner.title_img}`;
    }
    return `${this.imgUrl}${banner.title_img}`;
  }

  getRouterLink(banner: any): string {
    let route;
    if(banner.categoryId){
      localStorage.setItem('category', banner.categoryId);
    }
    if(banner?.series_id){
      route = this.whitelabelService.getPrefixedRoute('shows', banner.series_id);
    }else{
      route = this.whitelabelService.getPrefixedRoute('movies', banner.title, banner.vidLibId);
    }
    return route;
  }

  getQueryParams(banner: BannerItem): any {
    return banner.queryParams || { id: banner.vidLibId };
  }

  getRentPrice(banner: any): string {
    const price = banner.isChannelSubscribed ? banner.sub_value : banner.unSub_value;
    return price ? `${banner.currencySymbol}${price}` : '';
  }

  canWatch(banner: BannerItem): boolean {
    return banner.preparedVideoType === 'FREE' || (banner.isChannelSubscribed && banner.preparedVideoType === 'Sub') || (banner.isPPVSubscribed && banner.preparedVideoType === 'PPV');
  }

  getWatchText(banner: BannerItem): string {
    if (banner.series_id) {
      return `S${banner.season_number}E${banner.episode_number}`;
    }
    return this.watchText;
  }

  onSubscribe(banner: BannerItem, event: Event): void {
    event.stopPropagation();
    if (this.tvPurchaseRedirect.maybeShowSubscribe(banner?.title)) return;
    this.subscribe.emit(banner);
  }

  onRent(banner: BannerItem, event: Event): void {
    event.stopPropagation();
    if (this.tvPurchaseRedirect.maybeShowRent(banner?.title)) return;
    this.rent.emit(banner);
  }

  onWatch(banner: any, event: Event): void {
    const video = banner;
    console.log(video)
    event.stopPropagation();
    this.watch.emit(banner);
  }

  onWatchlistToggle(banner: BannerItem, event: Event): void {
    event.stopPropagation();
    this.watchlistToggle.emit(banner);
  }

  onBannerClick(banner: BannerItem): void {
    this.bannerClick.emit(banner);
  }

  onImageLoad(): void {
    console.log('Image loaded successfully');
  }

  onImageError(index: number) {
    this.banners[index].imageError = true;
  }

  private startAutoSlide(): void {
    if (this.isTrailerPlaying) return;
    // On TV: only auto-slide while banner is focused. Cycling slides when
    // user is on a carousel below creates peripheral motion that feels like
    // jitter/flicker. While focused on banner, user sees the slide variety;
    // when they move down, banner stays static.
    // On web: keep historical behavior (auto-slide regardless of focus).
    if (this.isTV && !this.isTvFocused) return;
    // On web/legacy: original guard — don't disrupt user when they actively
    // focus the banner (mouse hover / tab focus).
    if (!this.isTV && this.isTvFocused) return;
    this.clearAutoSlide();
    this.autoSlideTimer = setTimeout(() => {
      const banner = this.banners[this.currentIndex];
      if (!banner?.latestTrailer?.url && !banner?.latestTrailer?.mpdManifest) {
        this.next();
        return;
      }
      this.tryPlayTrailerWhenReady(banner);
    }, this.AUTO_SLIDE_DELAY);
  }

  private isAdaptiveTrailer(url: string): boolean {
    return url.endsWith('.m3u8') || url.endsWith('.mpd');
  }
  
  private tryPlayTrailerWhenReady(banner: any): void {
    const trailerUrl = this.getTrailerUrl(banner);
    if (!trailerUrl) return;
    if (this.isAdaptiveTrailer(trailerUrl)) {
      this.playTrailer(banner);
      return;
    }
    if (this.preloadVideoEl) {
      this.preloadVideoEl.src = '';
      this.preloadVideoEl.load();
    }
    const video = document.createElement('video');
    this.preloadVideoEl = video;
    video.src = trailerUrl;
    video.muted = true;
    video.preload = 'metadata';
    video.playsInline = true;
    const canPlay = () => {
      return video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA;
    };
    const onReady = () => {
      cleanup();
      this.playTrailer(banner);
    };
    const onFail = () => {
      cleanup();
      console.warn('Trailer not ready yet, waiting…');
      this.retryTrailerLoad(banner);
    };

    const cleanup = () => {
      video.removeEventListener('loadeddata', onReady);
      video.removeEventListener('canplay', onReady);
      clearTimeout(timeout);
    };
    if (canPlay()) {
      this.playTrailer(banner);
      return;
    }
    video.addEventListener('loadeddata', onReady);
    video.addEventListener('canplay', onReady);
    const timeout = setTimeout(onFail, 4000);
    video.load();
  }  
  
  private retryTrailerLoad(banner: any): void {
    if (this.isDragging) return;
    if (this.currentIndex !== this.banners.indexOf(banner)) return;
    setTimeout(() => {
      if (!this.isTrailerPlaying &&
          this.currentIndex === this.banners.indexOf(banner)) {
        this.tryPlayTrailerWhenReady(banner);
      }
    }, 1500);
  }
  
  private clearAutoSlide(): void {
    if (this.autoSlideTimer) {
      clearTimeout(this.autoSlideTimer);
      this.autoSlideTimer = null;
    }
  }
  
  // private playTrailer(banner: any): void {
  //   this.clearAutoSlide();
  //   this.destroyTrailer();
  //   this.activeVideoBannerId = banner.vidLibId;
  //   this.isTrailerPlaying = true;
  // }
  
  private getTrailerUrl(banner: any): string | null {
    const trailer = banner?.latestTrailer;
    if (!trailer) return null;
    if (this.isSafariApple()) {
      if (trailer.hlsManifest) return `${environment.flix_video}${trailer.hlsManifest}`;
      if (trailer.mpdManifest) return `${environment.flix_video}${trailer.mpdManifest}`;
    } else {
      if (trailer.mpdManifest) return `${environment.flix_video}${trailer.mpdManifest}`;
      if (trailer.hlsManifest) return `${environment.flix_video}${trailer.hlsManifest}`;
    }
    return trailer.url || null;
  }

  private async playTrailer(banner: any): Promise<void> {
    this.clearAutoSlide();
    this.destroyTrailer();
    this.activeVideoBannerId = banner.vidLibId;
    this.isTrailerPlaying = true;
    this.trailerStartTime = Date.now();
    const url = this.getTrailerUrl(banner);
    if (!url) return;
    setTimeout(async () => {
      const video = this.heroVideo?.nativeElement;
      if (!video) return;
      video.muted = this.isMuted;
      video.playsInline = true;
      video.autoplay = true;
      if (this.isAdaptiveTrailer(url)) {
        if (this.isSafariApple() && url.endsWith('.m3u8')) {
          await this.initFairPlay(video, url);
        } else if (window.shaka) {
          await this.initShaka(video, url);
        } else {
          video.src = url;
          try { await video.play(); } catch (e) {
            console.warn('Trailer autoplay failed', e);
            this.onTrailerEnded();
          }
        }
      }
      else {
        video.src = url;
        try {
          await video.play();
        } catch (e) {
          console.warn('Trailer autoplay failed', e);
          this.onTrailerEnded();
        }
      }
    });
  }
  
  private async initShaka(video: HTMLVideoElement, manifestUrl: string, attempt: number = 0) {
    try {
      shaka.polyfill.installAll();
      if (!shaka.Player.isBrowserSupported()) {
        console.warn('Shaka not supported, falling back');
        video.src = manifestUrl;
        await video.play();
        return;
      }
      this.shakaPlayer = new shaka.Player(video);
      this.shakaVideoEl = video;
      const licenseUrl = this.axinomService.getWidevineUrl();
      const authToken = this.axinomService.getWidevineToken();
      const persistentSupported = await this.drmCapability.supportsPersistentLicense();
      // Restore saved persistent DRM session if available (skipped on retry).
      const savedRaw = attempt === 0 ? localStorage.getItem('drm_persistent_session') : null;
      let restore: any = {};
      if (savedRaw && persistentSupported) {
        try {
          const saved = JSON.parse(savedRaw);
          restore = {
            persistentSessionOnlinePlayback: true,
            persistentSessionsMetadata: [{
              sessionId: saved.sessionId,
              initData: new Uint8Array(saved.initData),
              initDataType: saved.initDataType ?? 'cenc'
            }]
          };
        } catch (e) {}
      }
      this.shakaPlayer.configure({
        drm: {
          ...restore,
          servers: {
            'com.widevine.alpha': licenseUrl
          },
          advanced: {
            'com.widevine.alpha': {
              sessionType: persistentSupported ? 'persistent-license' : 'temporary',
              persistentStateRequired: persistentSupported,
            }
          }
        }
      });
      this.shakaPlayer.getNetworkingEngine().registerRequestFilter((type, request) => {
        if (type === shaka.net.NetworkingEngine.RequestType.LICENSE && authToken) {
          request.headers['X-AxDRM-Message'] = authToken;
          request.headers['Content-Type'] = 'application/octet-stream';
        }
      });
      // Save persistent session for reuse across components
      this.shakaPlayer.addEventListener('drmsessionupdate', () => {
        const sessions = this.shakaPlayer.getActiveSessionsMetadata();
        const p = sessions.find((s: any) => s.sessionType === 'persistent-license');
        if (p) {
          localStorage.setItem('drm_persistent_session', JSON.stringify({
            sessionId: p.sessionId,
            initData: Array.from(p.initData),
            initDataType: p.initDataType
          }));
        }
      });
      try {
        await this.shakaPlayer.load(manifestUrl);
        await video.play();
      } catch (loadErr) {
        // A stale/invalid saved persistent session can poison load() with
        // DRM.FAILED_TO_CREATE_SESSION. Clear it and retry once fresh.
        if (attempt === 0 && savedRaw) {
          console.warn('Banner Shaka load failed with restored session, clearing and retrying fresh', loadErr);
          localStorage.removeItem('drm_persistent_session');
          try { await this.shakaPlayer.destroy(); } catch {}
          this.shakaPlayer = null;
          return this.initShaka(video, manifestUrl, 1);
        }
        throw loadErr;
      }
    } catch (err) {
      console.error('Shaka init failed', err);
      this.onTrailerEnded();
    }
  }
  
  private isSafariApple(): boolean {
    const ua = navigator.userAgent;
    const isApple = /iPad|iPhone|iPod|Macintosh/.test(ua);
    const isSafari = /^((?!chrome|android).)*safari/i.test(ua);
    return isApple && isSafari;
  }

  private async initFairPlay(video: HTMLVideoElement, url: string): Promise<void> {
    try {
      const certUrl = this.axinomService.getFairPlayCertUrl();
      const licenseUrl = this.axinomService.getFairPlayUrl();
      const token = this.axinomService.getFairplayToken();

      if (!this.fpCertificate) {
        const resp = await fetch(certUrl, { mode: 'cors' });
        if (!resp.ok) throw new Error(`Certificate fetch failed: ${resp.status}`);
        this.fpCertificate = await resp.arrayBuffer();
      }

      this.shakaVideoEl = video;

      video.addEventListener('encrypted', async (event: MediaEncryptedEvent) => {
        if (event.initDataType !== 'skd' || !event.initData) return;
        if (!video.mediaKeys) {
          const config: MediaKeySystemConfiguration[] = [{
            initDataTypes: ['skd'],
            videoCapabilities: [{ contentType: 'video/mp4', robustness: '' }],
            distinctiveIdentifier: 'not-allowed',
            persistentState: 'not-allowed',
            sessionTypes: ['temporary'],
          }];
          let access: MediaKeySystemAccess;
          try {
            access = await navigator.requestMediaKeySystemAccess('com.apple.fps.1_0', config);
          } catch {
            access = await navigator.requestMediaKeySystemAccess('com.apple.fps', config);
          }
          const keys = await access.createMediaKeys();
          await keys.setServerCertificate(this.fpCertificate!);
          await video.setMediaKeys(keys);
        }
        if (!this.fpKeySession) {
          this.fpKeySession = video.mediaKeys!.createSession('temporary');
          this.fpKeySession.addEventListener('message', async (msgEvt: any) => {
            try {
              const resp = await fetch(licenseUrl, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/octet-stream',
                  'X-AxDRM-Message': token,
                },
                body: msgEvt.message,
              });
              if (!resp.ok) throw new Error(`License failed: ${resp.status}`);
              const ckc = await resp.arrayBuffer();
              await this.fpKeySession!.update(ckc);
            } catch (e) {
              console.error('FairPlay license error:', e);
              this.onTrailerEnded();
            }
          });
        }
        const data = new Uint8Array(event.initData);
        let str = '';
        for (let i = 0; i < data.length; i++) {
          if (data[i] === 0) continue;
          str += String.fromCharCode(data[i]);
        }
        const skdIndex = str.indexOf('skd://');
        if (skdIndex === -1) throw new Error('No skd:// in initData');
        const tail = str.substring(skdIndex);
        const end = tail.search(/[\s'"]/);
        const skdUri = end === -1 ? tail.trim() : tail.substring(0, end).trim();
        await this.fpKeySession.generateRequest('skd', new TextEncoder().encode(skdUri).buffer);
      });

      video.src = url;
      video.load();
      try {
        await video.play();
      } catch (e) {
        console.warn('FairPlay trailer autoplay failed', e);
        this.onTrailerEnded();
      }
    } catch (e) {
      console.error('FairPlay init failed:', e);
      this.onTrailerEnded();
    }
  }

  onTrailerEnded(): void {
    this.destroyTrailer();
    this.next();
  }

  private destroyTrailer(): void {
    this.updateTrailerWatchHistory();
    if (this.shakaPlayer) {
      this.shakaPlayer.destroy();
      this.shakaPlayer = null;
    }
    if (this.fpKeySession) {
      try { this.fpKeySession.close(); } catch {}
      this.fpKeySession = null;
    }
    if (this.shakaVideoEl) {
      this.shakaVideoEl.pause();
      this.shakaVideoEl.removeAttribute('src');
      this.shakaVideoEl.load();
      this.shakaVideoEl = null;
    }
    this.activeVideoBannerId = null;
    this.isTrailerPlaying = false;
    if (!this.userMutedManually) {
      this.isMuted = true;
    }
  }

  private updateTrailerWatchHistory(): void {
    if (!this.isTrailerPlaying || !this.activeVideoBannerId) return;
    const userId = localStorage.getItem('userId');
    if (!userId) return;
    const banner = this.banners.find(b => b.vidLibId == this.activeVideoBannerId);
    if (!banner) return;
    const video = this.heroVideo?.nativeElement;
    const secondsWatched = this.trailerStartTime > 0 ? Math.round((Date.now() - this.trailerStartTime) / 1000) : 0;
    if (secondsWatched <= 0) return;
    const now = new Date();
    const createdOn = `${now.getDate()}-${now.toLocaleString('default', { month: 'short' })}-${now.getFullYear()} ${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`;
    const requestBody: any = {
      "channel": banner.channelId,
      "isDrmVideo": "1",
      "playBackMode": "server",
      "playState": "1",
      "secondsWatched": `${secondsWatched}`,
      "currentPlaybackPosition": `${video?.currentTime || 0}`,
      "subtitleLanguage": "Stereo, 0.13 Mbps",
      "videoDuration": `${video?.duration || 0}`,
      "videoFileSIze": `${banner.videoFileSize || 0}`,
      "videoId": this.activeVideoBannerId,
      "videoType": banner.videoType,
      "createdOn": createdOn,
      "eventId": "13",
      "eventType": "13",
      "userId": userId,
      "platformType": this.deviceService.getPlatformType(),
      "trailerTitle": banner.title,
      "contentType": "TRAILER"
    };
    this.mycontentserviceService.updateUserVideoTracking(requestBody).subscribe({
      next: () => console.log('Banner trailer watch history updated:', secondsWatched, 's'),
      error: (err) => console.error('Error updating banner trailer watch history:', err)
    });
  }

  // private destroyTrailer(): void {
  //   this.activeVideoBannerId = null;
  //   this.isTrailerPlaying = false;
  //   this.isMuted = true;
  //   this.userMutedManually = false;
  // }

  @HostListener('document:visibilitychange')
  onVisibilityChange(): void {
    if (document.hidden) {
      this.wasHidden = true;
      this.clearAutoSlide();
      this.destroyTrailer();
    } else {
      if (this.wasHidden) {
        this.wasHidden = false;
        if (this.userMutedManually) return;
        setTimeout(() => {
          this.startAutoSlide();
        }, 2000);
      }
    }
  }

  toggleMute(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    this.blockNextNavigation = true;
    this.userMutedManually = true;
    this.clearAutoSlide();
    this.isMuted = !this.isMuted;
    const video = this.heroVideo?.nativeElement;
    if (video) {
      video.muted = this.isMuted;
      video.volume = this.isMuted ? 0 : 1;
    }
    setTimeout(() => {
      this.blockNextNavigation = false;
    }, 400);
  }  

  onBannerNavigate(banner: any, event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    if (this.blockNextNavigation) return;
    if (this.isDragging) return;
    if (this.isTrailerPlaying) return;
    this.router.navigate(
      [this.getRouterLink(banner)],
      { queryParams: this.getQueryParams(banner) }
    );
  }  
}











































// import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
// import { OwlOptions } from 'ngx-owl-carousel-o';
// import { URLS } from 'src/app/constants/URLS';
// import { environment } from 'src/environments/environment';

// export interface BannerItem {
//   vidLibId: string | number;
//   title: string;
//   title_img?: string;
//   channel_desc?: string;
//   pg_rating?: string;
//   duration?: string;
//   category?: string;
//   description?: string;
//   genres?: string[];
//   preparedVideoType: 'FREE' | 'Sub' | 'PPV';
//   isChannelSubscribed?: boolean;
//   isPPVSubscribed?: boolean;
//   isInWatchList?: boolean;
//   channelId?: string | number;
//   videoType?: string;
//   durationInSeconds?: number;
//   videoFileSize?: number;
//   secondsWatched?: number;
//   series_id?: string | number;
//   season_number?: number;
//   episode_number?: number;
//   ppv_subscribed?: number;
//   ppv_unsubscribed?: number;
//   routerLink?: string;
//   queryParams?: any;
// }

// @Component({
//   selector: 'app-banner',
//   templateUrl: './banner.component.html',
//   styleUrls: ['./banner.component.css']
// })
// export class BannerComponent implements OnInit {
//   @Input() banners: BannerItem[] = [];
//   @Input() showTitle: boolean = true;
//   @Input() showMetaInfo: boolean = true;
//   @Input() showDescription: boolean = true;
//   @Input() showGenres: boolean = true;
//   @Input() showButtons: boolean = true;
//   @Input() showWatchlist: boolean = true;
//   @Input() subscribeText: string = 'Subscribe to watch';
//   @Input() rentText: string = 'Watch for';
//   @Input() watchText: string = 'Watch Now';
//   @Input() customCarouselOptions?: OwlOptions;
//   @Input() baseImageUrl?: string;
//   @Input() baseTitleImageUrl?: string;

//   @Output() subscribe = new EventEmitter<BannerItem>();
//   @Output() rent = new EventEmitter<BannerItem>();
//   @Output() watch = new EventEmitter<BannerItem>();
//   @Output() watchlistToggle = new EventEmitter<BannerItem>();
//   @Output() bannerClick = new EventEmitter<BannerItem>();

//   mediaUrl: string = URLS.BASE_URL + '/static/post_videos/';
//   env: string = environment.TQR_SERVICE;

//   constructor() { }

//   ngOnInit(): void {
//   }

//   carouselOptions: OwlOptions = {
//       loop: true,
//       mouseDrag: true,
//       touchDrag: true,
//       pullDrag: true,
//       dots: true,
//       navSpeed: 700,
//       nav: false,
//       autoplay: true,
//       autoplayTimeout: 8000,
//       autoplayHoverPause: true,
//       navText: ['<i class="fa fa-chevron-left"</i>', '<i class="fa fa-chevron-right"</i>'],
//       items: 1,
//       margin: 0,
//       responsive: {
//         0: {
//           nav: false,
//           dots: true
//         },
//         600: {
//           nav: false,
//           dots: true
//         },
//         1000: {
//           nav: true,
//           dots: true
//         }
//       }
//     };


//   getHorizontalImage(banner: any) {
//     if(banner?.series_id){
//       return `${this.env}cms/ContentController/file/SER_${banner?.series_id}_thumb_b.jpg`;
//     }else{
//       return `${this.env}cms/ContentController/file/VID_${banner?.vidLibId}_thumb_b.jpg`;
//     }
//   }

//   getVerticalImage(banner: BannerItem): string {
//     if(banner?.series_id){
//       return `${this.env}cms/ContentController/file/SER_${banner?.series_id}_thumb_v.jpg`;
//     }else{
//       return `${this.env}cms/ContentController/file/VID_${banner?.vidLibId}_thumb_v.jpg`;
//     }
//   }

//   getTitleImage(banner: BannerItem): string {
//     if (this.baseTitleImageUrl) {
//       return `${this.baseTitleImageUrl}${banner.title_img}`;
//     }
//     return `${this.env}cms/ContentController/file/${banner.title_img}`;
//   }

//   getRouterLink(banner: BannerItem): string {
//     return banner.routerLink || '/tqr/video-details';
//   }

//   getQueryParams(banner: BannerItem): any {
//     return banner.queryParams || { id: banner.vidLibId };
//   }

//   getRentPrice(banner: any): string {
//     const price = banner.isChannelSubscribed ? banner.sub_value : banner.unSub_value;
//     return price ? `₹${price}` : '';
//   }

//   canWatch(banner: BannerItem): boolean {
//     return banner.preparedVideoType === 'FREE' || (banner.isChannelSubscribed && banner.preparedVideoType === 'Sub') || (banner.isPPVSubscribed && banner.preparedVideoType === 'PPV');
//   }

//   getWatchText(banner: BannerItem): string {
//     if (banner.series_id) {
//       return `S${banner.season_number}E${banner.episode_number}`;
//     }
//     return this.watchText;
//   }

//   onSubscribe(banner: BannerItem, event: Event): void {
//     event.stopPropagation();
//     this.subscribe.emit(banner);
//   }

//   onRent(banner: BannerItem, event: Event): void {
//     event.stopPropagation();
//     this.rent.emit(banner);
//   }

//   onWatch(banner: BannerItem, event: Event): void {
//     event.stopPropagation();
//     this.watch.emit(banner);
//   }

//   onWatchlistToggle(banner: BannerItem, event: Event): void {
//     event.stopPropagation();
//     this.watchlistToggle.emit(banner);
//   }

//   onBannerClick(banner: BannerItem): void {
//     this.bannerClick.emit(banner);
//   }
// }